<template>
  <div class="d-flex flex-column app-side-nav-container">
    <div id="app-side-nav--policy-connect-version" v-show="0">
      {{ version }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { CSBase } from '@complispace/cs-design-system';

const packageParam = require('../../../package.json');

export default {
  name: 'AppSideNavPublic',

  extends: CSBase,

  data() {
    return {};
  },

  computed: {
    ...mapState({
      app: (state) => state.app,
      client: (state) => state.client
    }),

    version() {
      const { bundleVersion } = packageParam;
      const uiVersion = packageParam.version;
      const dashApiVersion = this.app.apiVersion ? `-${this.app.apiVersion}` : '';
      const contentEngineVersion = this.app.ceVersion ? `-${this.app.ceVersion}` : '';
      return `${bundleVersion}#${uiVersion}${dashApiVersion}${contentEngineVersion}`;
    }
  }
};
</script>

<style></style>
